import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ADMIN_PAGES_KEYS, NS, ORG_SETTINGS_KEYS } from '../../../i18n/constants/keys';
import {
  CommandIcons,
  ComponentsIcons,
  UsersIcons,
} from '../../../icons/icons';
import { RoleIcon, UserIcon, Users } from '../../../ui/icons/icons';
import {
  PrimaryTypography,
  SecondaryTypography,
} from '../../../ui/typography/typography';
import { fetchOrganizationUsers } from '../../../utils/redux_store/features/organization_user_reducer';
import { fetchUserGroups } from '../../../utils/redux_store/features/user_group_reducer';
import { fetchUserRoles } from '../../../utils/redux_store/features/user_role_reducer';
import { RootState, store } from '../../../utils/redux_store/store';
import { Tabs } from '../../assessment/view/tabs/tabs';
import commonStyles from '../admin.module.css';
import styles from './access_management.module.css';
import { GroupManagement } from './group_management/group_management';
import { RoleManagement } from './role_management/role_management';
// import { Permission } from '../../../utils/helpers/permissions';

export const AccessManagement = () => {
  const { t } = useTranslation(NS.adminPages);
  const [activeTab, setActiveTab] = useState<number>(0);
  const tabTitles = [
    t(ADMIN_PAGES_KEYS.accessManagement.tabs.groups),
    t(ADMIN_PAGES_KEYS.accessManagement.tabs.roles),
  ];
  const userCount = useSelector(
    (state: RootState) => state.organizationUsers?.organizationUserList?.length ?? 0,
  );
  const groupCount = useSelector(
    (state: RootState) => state.userGroups?.userGroupList?.length ?? 0,
  );
  const roleCount = useSelector(
    (state: RootState) => state.userRoles?.userRoleList?.length ?? 0,
  );

  useEffect(() => {
    store.dispatch(fetchOrganizationUsers());
    store.dispatch(fetchUserGroups());
    store.dispatch(fetchUserRoles());
  }, []);

  const renderTabContent = () => {
    if (activeTab === 0) {
      return <GroupManagement />;
    } else if (activeTab === 1) {
      return <RoleManagement />;
    }
  };

  return (
    <div className='w-full h-full flex flex-col gap-5'>
      { /*{console.log(Permission)}*/ }
      <nav
          className='flex w-full justify-between items-center border-b py-3 text-sm'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center space-x-1 md:space-x-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              {t(ORG_SETTINGS_KEYS.breadcrumbs.admin)}
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-dark font-semibold hover:underline'
            >
              {t(ADMIN_PAGES_KEYS.accessManagement.title)}
            </Link>
          </li>{ ' ' }
          <li>
            <span className='text-gray-400'>/</span>
          </li>
        </ol>
      </nav>
      <div>
        <div
            className='
    flex items-center gap-8 p-2 bg-white border border-gray-200 rounded-xl shadow-sm
    justify-center
    max-w-lg mx-auto
  '
        >
          { /* Users */ }
          <div className='flex items-center gap-2 px-2'>
            <div className='w-8 h-8 flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50'>
              <UsersIcons className='w-5 h-5 text-gray-600' />
            </div>
            <span className='text-sm font-medium text-gray-900 tracking-tight'>
              { userCount }
            </span>
            <span className='text-xs text-gray-500'>
              {t(ADMIN_PAGES_KEYS.accessManagement.users)}
            </span>
          </div>
          { /* Groups */ }
          <div className='flex items-center gap-2 px-2 border-l border-gray-200'>
            <div className='w-8 h-8 flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50'>
              <ComponentsIcons className='w-5 h-5 text-gray-600' />
            </div>
            <span className='text-sm font-medium text-gray-900 tracking-tight'>
              { groupCount }
            </span>
            <span className='text-xs text-gray-500'>
              {t(ADMIN_PAGES_KEYS.accessManagement.groups)}
            </span>
          </div>
          { /* Roles */ }
          <div className='flex items-center gap-2 px-2 border-l border-gray-200'>
            <div className='w-8 h-8 flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50'>
              <CommandIcons className='w-5 h-5 text-gray-600' />
            </div>
            <span className='text-sm font-medium text-gray-900 tracking-tight'>
              { roleCount }
            </span>
            <span className='text-xs text-gray-500'>
              {t(ADMIN_PAGES_KEYS.accessManagement.roles)}
            </span>
          </div>
        </div>

        <Tabs
            tabTitles={tabTitles}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
        />
        { renderTabContent() }
      </div>
    </div>
  );
};
